import type { OfficeSpot } from './api'
import type { Pos } from './arena'

/** Close enough to start talking, and how much further you can drift before the call drops. */
export const NEAR_IN = 260
export const NEAR_OUT = 340

/**
 * Whether two people should be on a call. Both must have chosen to turn their microphone or camera
 * on, and they must be standing near each other; once connected they stay connected a little further
 * out, so hovering at the edge does not flap.
 */
export function shouldConnect(me: Pos, iHaveMedia: boolean, peer: OfficeSpot | null, connected: boolean): boolean {
  if (!iHaveMedia || !peer || !(peer.mic || peer.cam)) return false
  return Math.hypot(peer.x - me.x, peer.y - me.y) < (connected ? NEAR_OUT : NEAR_IN)
}

/** Exactly one side starts a call, so two people never offer at once. */
export const isInitiator = (meId: string, peerId: string): boolean => meId < peerId
